import classNames from 'classnames'
import styles from './ContactName.module.scss'

interface Props {
    name: string
    className?: string
}

const ContactName = ({ name, className = '' }: Props) => (
    <span title={name} className={classNames(className, styles.contactName)}>
        {name}
    </span>
)

export default ContactName
